import { useState } from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, StyledFlex, Button } from '@tryhackme/thm-ui-components';
import { InviteTeammates } from '../invite-teammates';
import { StyledBanner, StyledTitle, StyledLink, StyledDescription, StyledDesktopImage, StyledMobileImage, StyledContentWrapper } from './banner.styles';
import { BannerProps } from './banner.types';
export const Banner: React.FC<BannerProps> = ({
  title,
  description,
  summary,
  image,
  isCtfModule
}) => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  return <StyledBanner data-sentry-element="StyledBanner" data-sentry-component="Banner" data-sentry-source-file="banner.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="banner.tsx">
        <StyledContentWrapper data-testid="auth-banner-content" data-sentry-element="StyledContentWrapper" data-sentry-source-file="banner.tsx">
          <StyledFlex flexDirection="column" alignItems="flex-start" gap="3.2rem" data-sentry-element="StyledFlex" data-sentry-source-file="banner.tsx">
            <StyledLink to="/hacktivities?tab=modules" data-sentry-element="StyledLink" data-sentry-source-file="banner.tsx">
              <FontAwesomeIcon icon={faArrowLeft} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="banner.tsx" /> Back to all modules
            </StyledLink>
            <StyledFlex gap="3.2rem" flexWrap="no-wrap" data-sentry-element="StyledFlex" data-sentry-source-file="banner.tsx">
              <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="banner.tsx">{title}</StyledTitle>
              <StyledMobileImage src={image} alt={`${title} icon`} data-sentry-element="StyledMobileImage" data-sentry-source-file="banner.tsx" />
            </StyledFlex>
            <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="banner.tsx">{summary}</StyledDescription>
            <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="banner.tsx">{description}</StyledDescription>
            {isCtfModule && <InviteTeammates onOpenChange={isOpen => setShowInviteModal(isOpen)} open={showInviteModal} moduleName={title} triggerElement={<Button variant="solid" color="primary">
                    Invite teammates
                  </Button>} />}
          </StyledFlex>
          <StyledDesktopImage src={image} alt={`${title} icon`} data-sentry-element="StyledDesktopImage" data-sentry-source-file="banner.tsx" />
        </StyledContentWrapper>
      </Container>
    </StyledBanner>;
};